export enum TipoTab {
  NUMERO_CLIENTE = 'Número de cliente',
  RUT = 'RUT',
}
